import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_x6hjf3asq3: FaireBrandEntity = {
  token: "b_x6hjf3asq3",
  type: "brand",
  name: "Surf Gems",
  avatarUrl:
    "https://cdn.faire.com/fastly/33fd8f1864873f10b982ce134d0539da96dbededed11717cf1bbd14aca932aee.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5623dffadbb25fb1d8d8ffdeeeb739688a1ff82c5b27e01ea12260d86b8f3c79.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/33fd8f1864873f10b982ce134d0539da96dbededed11717cf1bbd14aca932aee.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5623dffadbb25fb1d8d8ffdeeeb739688a1ff82c5b27e01ea12260d86b8f3c79.jpeg",
  location: "Morro Bay, CA, USA",
  minimumOrderDollars: 400,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "Surf Gems creates one-of-a-kind handcrafted jewelry made from reclaimed surfboard resin. Each piece features naturally layered color patterns formed during the surfboard glassing process. No two gems are ever the same.\n\nFounded by California surfer and artist Abby Ahlgrim, Surf Gems blends craftsmanship, sustainability, and self-expression. The result is lightweight, eye-catching jewelry that tells a story and stands out on the shelf.\n\nDesigned for easy merchandising and strong sell-through, Surf Gems resonates with customers looking for meaningful, modern jewelry with a clear point of difference.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:34.059Z",
    importedBy: "entity-db-cli",
  },
};
